// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function bgClassOfState(stepState) {
  if (typeof stepState !== "object") {
    return "bg-zinc-300";
  }
  if (stepState.NAME === "active") {
    return "bg-tan-blue-500";
  }
  var match = stepState.VAL;
  if (match === "valid") {
    return "bg-tan-success";
  } else if (match === "invalid") {
    return "bg-tan-error-500";
  } else {
    return "bg-zinc-300";
  }
}

function textClassOfState(stepState) {
  if (stepState === "untouched") {
    return "text-zinc-700";
  } else {
    return "text-white";
  }
}

function sizeClassOfState(stepState) {
  if (typeof stepState === "object" && stepState.VAL !== "unknown") {
    return "text-sm";
  } else {
    return "text-lg w-6 h-6";
  }
}

function PropertyWizardStepIconRelay$StepNumber(props) {
  var stepNumber = props.stepNumber;
  var stepState = props.stepState;
  var tmp;
  if (typeof stepState === "object") {
    var match = stepState.VAL;
    tmp = match === "valid" ? JsxRuntime.jsx(Icon__Jsx3.make, {
            icon: "OkCircled",
            size: 24
          }) : (
        match === "invalid" ? JsxRuntime.jsx(Icon__Jsx3.make, {
                icon: "CancelCircled",
                size: 24
              }) : stepNumber.toString()
      );
  } else {
    tmp = stepNumber.toString();
  }
  return JsxRuntime.jsx("span", {
              children: tmp,
              className: TailwindMerge.twMerge([
                    "absolute right-2 top-1/2 -mt-3 rounded-full flex justify-center items-center text-center font-semibold sm:-top-2 sm:-right-2 sm:mt-0",
                    bgClassOfState(stepState),
                    textClassOfState(stepState),
                    sizeClassOfState(stepState)
                  ])
            });
}

var StepNumber = {
  bgClassOfState: bgClassOfState,
  textClassOfState: textClassOfState,
  sizeClassOfState: sizeClassOfState,
  make: PropertyWizardStepIconRelay$StepNumber
};

function className(active) {
  return TailwindMerge.twMerge([
              "bg-white flex items-center justify-center w-[42px] h-[42px] rounded-full border-2 static text-center",
              "sm:relative sm:z-10 sm:mt-0 sm:mx-auto sm:mb-3 sm:w-[52px] sm:h-[52px]",
              active ? "text-tan-blue-500 border-tan-blue-500" : "text-zinc-500 border-zinc-300"
            ]);
}

function PropertyWizardStepIconRelay$StepGraphic(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Icon__Jsx3.make, {
                      icon: props.icon,
                      size: 24
                    }),
                JsxRuntime.jsx(PropertyWizardStepIconRelay$StepNumber, {
                      stepState: props.stepState,
                      stepNumber: props.stepNumber
                    })
              ],
              className: className(props.active)
            });
}

var StepGraphic = {
  className: className,
  make: PropertyWizardStepIconRelay$StepGraphic
};

function PropertyWizardStepIconRelay(props) {
  return JsxRuntime.jsxs("button", {
              children: [
                JsxRuntime.jsx(PropertyWizardStepIconRelay$StepGraphic, {
                      icon: props.icon,
                      stepState: props.stepState,
                      stepNumber: props.stepNumber,
                      active: props.active
                    }),
                JsxRuntime.jsx("h5", {
                      children: props.label,
                      className: "mb-0 text-zinc-700 font-medium text-lg leading-6 sm:text-lg sm:leading-6"
                    })
              ],
              className: "bg-transparent border-0 cursor-pointer flex items-center gap-x-2 sm:inline-block",
              onClick: props.onClick
            });
}

var Step;

var make = PropertyWizardStepIconRelay;

exports.Step = Step;
exports.StepNumber = StepNumber;
exports.StepGraphic = StepGraphic;
exports.make = make;
/* Icon__Jsx3 Not a pure module */
